import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-WalletShape",
  "use": "svg-icon-WalletShape-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-WalletShape\"><path d=\"M0 3c0-1.657 1.348-3 3-3h6.997v.508a.998.998 0 0 1-.995.992H2.997C2.447 1.5 2 1.954 2 2h7.003C10.106 2 11 2.887 11 3.998v4.004A2 2 0 0 1 9.008 10H1.992A1.99 1.99 0 0 1 0 8V3zm1.5 1.5v3c0 .556.446 1 .997 1h6.006c.544 0 .997-.448.997-1v-3c0-.556-.446-1-.997-1H2.497c-.544 0-.997.448-.997 1zM6 6c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol